import gql from 'graphql-tag';

export const MUTATION_COMPLETE_EQUIPMENT_COUNTING_JOURNAL = gql`
  mutation completeEquipmentCountingJournal($id: String!) {
    completeEquipmentCountingJournal(id: $id) {
      id
      journalNum
      status
      lineCount
      countedCount
    }
  }
`;